import axios from 'axios';

import { Id, PagedParams, PagedResponse, getData } from '@feature/utils';

import { Patent, PatentReclaimSearch, PatentRequest, PatentSearchRequest } from './PatentTypes';

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<Patent>>('/author/patents/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<Patent>(`/author/patents/${id}`).then(getData);
}

export function edit(id: Id, request: PatentRequest) {
  return axios.put<Patent>(`/author/patents/${id}`, request).then(getData);
}

export function create(request: PatentRequest) {
  return axios.post<Patent>(`/author/patents`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/author/patents/${id}`).then(getData);
}

export function searchByIdentifiers(request: PatentSearchRequest) {
  return axios
    .get<PatentReclaimSearch>('/author/patents/search/by-id', {
      params: {
        ...request,
      },
    })
    .then(getData);
}

export function reclaimAuthorship(patentId: number, authorId: number) {
  return axios.post<unknown>(`/author/patents/${patentId}/reclaim-authorship/${authorId}`).then(getData);
}
